module.exports = __webpack_public_path__ + "img/yhk.e554163b.png";